import { Link } from "react-router-dom";
import BootstrapTable from "react-bootstrap-table-next";
import React, { useState, useEffect, useRef } from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import {
  getLeaveRequestsByEmployeeId,
  updateLeaveRequest,
  getVacationDays,
  getLeaveStats,
} from "../../../../services/RHService/LeaveRequestService";
import { getLeaveType } from "../../../../services/RHService/LeaveTypeService";
import paginationFactory from "react-bootstrap-table2-paginator";
import getCurrentUserId from "../../../../reduxSaga/sagas/requests/currentUserId";
import uploadAndDownloadService from "../../../../services/uploadAndDownloadFile";

import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min";
/* import jsPDF from "jspdf";
 */ /* import "jspdf-autotable"; */
const EmployeeLeaveRequests = () => {
  //variables

  const [selectedFile, setSelectedFile] = useState(null);

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const [showModify, setShowModify] = useState(false);
  const handleCloseModify = () => setShowModify(false);
  const [leaveRequests, setLeaveRequests] = useState([]);
  const [differenceEnJours, setDifferenceEnJours] = useState(null);
  const [info, setInfo] = useState(null);

  useEffect(() => {
    fetchDataLeaveStat();
  }, []);

  const fetchDataLeaveStat = async () => {
    let user = JSON.parse(localStorage.getItem("user"));
    const userId = user.token.idUser;
    const leaveStats = await getLeaveStats(userId);

    if (leaveStats.success === null) {
      setInfo();
    }
    setInfo(leaveStats.success);
  };

  // show leave request details
  useEffect(() => {
    fetchData();
  }, []);
  const fetchData = async () => {
    let user = JSON.parse(localStorage.getItem("user"));
    const userId = user.token.idUser;
    const checkIfHavePermission = await getVacationDays(userId);

    const data = await getLeaveRequestsByEmployeeId(userId);
    if (data === null || checkIfHavePermission === null) {
      setLeaveRequests();
    }
    setLeaveRequests(data);
  };
  const [fileData, setFileData] = useState(null);
  const [selectedLeaveRequest, setSelectedLeaveRequest] = useState(null);
  const [file, setFile] = useState(null);

  const handleShow = async (leaveRequest) => {
    setSelectedLeaveRequest(leaveRequest);
    // if (leaveRequest && leaveRequest.fileUrl) {
    // setFileData(leaveRequest.fileUrl);
    setShow(true);
    // }
  };

  useEffect(() => {
    if (selectedLeaveRequest) {
      const dateDeb = new Date(selectedLeaveRequest.dateDeb);
      const dateFin = new Date(selectedLeaveRequest.dateFin);

      const differenceEnMillisec = dateFin - dateDeb;
      const differenceEnJours = differenceEnMillisec / (1000 * 60 * 60 * 24);

      setDifferenceEnJours(differenceEnJours); // Update the state with the calculated value
    }
  }, [selectedLeaveRequest]);
  // show leave request details

  // Modify leave request details
  const [selectedLeaveRequestForModify, setSelectedLeaveRequestForModify] =
    useState(null);

  const handleShowModify = async (leaveRequest) => {
    setSelectedLeaveRequestForModify(leaveRequest);
    // if (leaveRequest && leaveRequest.fileUrl) {
    // setFileData(leaveRequest.fileUrl);
    setShowModify(true);
    // }
  };
  const [leaveType, setLeaveType] = useState([]);
  useEffect(() => {
    getLeaveType(getCurrentUserId())
      .then((names) => {
        setLeaveType(names.success);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  //colonnes de table
  const columns = [
    { dataField: "nomConge", text: "Type de congé" },
    { dataField: "dateDeb", text: "Congé de " },
    { dataField: "dateFin", text: "A" },
    { dataField: "nbJrs", text: "Nombre de jours" },
    {
      dataField: "p",
      text: "Superviseur",
      formatter: (cell, row) => {
        const { supervisorFirstName, supervisorLastName } = row;
        const fullName = `${supervisorFirstName || "-"} ${
          supervisorLastName || "-"
        }`;
        return fullName;
      },
    },

    {
      dataField: "status",
      text: "Status",
      formatter: (cell, row) => {
        let badgeClass = "";
        let badgeText = "";
        if (cell === "PENDING") {
          badgeClass = "badge_leave col-blue";
          badgeText = "En attente";
        } else if (cell === "APPROVED") {
          badgeClass = "badge_leave col-green";
          badgeText = "Approuvé";
        } else if (cell === "REJECTED") {
          badgeClass = "badge_leave col-orange";
          badgeText = "Refusé";
        }
        return (
          <div className="center">
            <div className={badgeClass}>{badgeText}</div>
          </div>
        );
      },
    },
    {
      dataField: "action",
      text: "Action",
      formatter: (cell, row) => {
        if (row.status !== "PENDING") {
          return (
            <div className="center">
              {" "}
              <button
                style={{
                  "background-color": "white",
                  "border-color": "transparent",
                }}
                onClick={() => {
                  handleShow(row);
                }}
              >
                <i className="fa-solid fa-eye eye-icon"></i>
              </button>
            </div>
          );
        }
        return (
          <div className="center">
            <Button
              style={{
                "background-color": "white",
                color: "black",
                "border-color": "transparent",
              }}
              onClick={() => {
                handleShowModify(row);
                console.log(row);
              }}
            >
              <i class="fa-solid fa-pencil"></i>
            </Button>
            <button
              style={{
                "background-color": "white",
                "border-color": "transparent",
              }}
              onClick={() => {
                handleShow(row);
              }}
            >
              <i className="fa-solid fa-eye eye-icon"></i>
            </button>
          </div>
        );
      },
    },
  ];

  function calculateDateDifference(startDate, endDate) {
    const oneDay = 24 * 60 * 60 * 1000; // hours * minutes * seconds * milliseconds
    const start = new Date(startDate);
    const end = new Date(endDate);
    const diffInDays = Math.round(Math.abs((start - end) / oneDay));
    return diffInDays;
  }
  //pagination
  const options = {
    sizePerPage: 5,
    hideSizePerPage: true,
    hidePageListOnlyOnePage: true,
    paginationPosition: "bottom",
  };
  const fileInputRef = useRef(null);
  const [leaveTypeError, setLeaveTypeError] = useState("");

  const handleUpdate = async (event) => {
    event.preventDefault();
    if (
      !selectedLeaveRequestForModify.idLeaveType ||
      selectedLeaveRequestForModify.idLeaveType === "leaveType"
    ) {
      setLeaveTypeError("Veuillez saisir un Type de congé");
    } else {
      setLeaveTypeError("");
    }
    if (
      !selectedLeaveRequestForModify.dateDeb ||
      !selectedLeaveRequestForModify.dateFin
    ) {
      toastr.error("Veillez renseigner les champs Date début et Date Fin !.");
      return;
    }
    if (
      new Date(selectedLeaveRequestForModify.dateDeb) >
      new Date(selectedLeaveRequestForModify.dateFin)
    ) {
      toastr.error("La date de début doit être antérieure à la date de fin.");
      return;
    }
    // let user = JSON.parse(localStorage.getItem("user"));
    // const userId = user.token.idUser
    // const checkIfHavePermission = await getVacationDays(userId);
    // let takenDays = parseInt(checkIfHavePermission.takenDays);
    // let rf = takenDays + parseInt(formData.nbJrs);

    // if (rf > checkIfHavePermission.remainingDays) {
    //   toastr.error("Il ne vous reste plus de jours de congé.");
    //   return;
    // }

    if (
      selectedLeaveRequestForModify.idLeaveType &&
      selectedLeaveRequestForModify.idLeaveType !== "leaveType"
    ) {
      const response = await updateLeaveRequest(
        file,
        selectedLeaveRequestForModify,
        selectedLeaveRequestForModify.fileUrl
      );
      if (response.status === 200) {
        toastr.success("Demande modifier avec succée.");
        fetchData();
        handleCloseModify();
      }
    }
  };

  const onUploadFileHandler = (path) => {
    onShowFileInOtherWizndowHandler(path);
  };

  const onShowFileInOtherWizndowHandler = (path) => {
    uploadAndDownloadService
      .downloadFile(path)
      .then((response) => {
        //Build a URL from the file
        if (response.headers["content-type"] === "image/png") {
          const file = new Blob([response.data], { type: "image/png" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        } else if (response.headers["content-type"] === "application/pdf") {
          const file = new Blob([response.data], { type: "application/pdf" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        } else if (response.headers["content-type"] === "image/jpeg") {
          const file = new Blob([response.data], { type: "image/jpeg" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        } else if (response.headers["content-type"] === "image/jpg") {
          const file = new Blob([response.data], { type: "image/jpg" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };
  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <ToolkitProvider
        keyField="id"
        data={leaveRequests}
        columns={columns}
        exportCSV={{
          fileName: "Mes_employes.csv",
          onlyExportFiltered: true,
          exportAll: false,
        }}
        search
      >
        {(props) => (
          <div>
            {/* datail de congé */}
            <Modal show={show} onHide={handleClose} size="xl">
              <Modal.Header closeButton>
                <Modal.Title>Détail de congé</Modal.Title>
              </Modal.Header>
              <Modal.Body className="show-grid">
                <Form>
                  <Container>
                    <Row>
                      <div className="col-md-12">
                        <div class="card">
                          <div className="card-header">
                            <h5>Détails</h5>
                          </div>
                          <div class="card-body">
                            <div class="row">
                              <div className="col-md-3">
                                <strong className="center">
                                  Nom et Prenom
                                </strong>
                                <br></br>
                                {selectedLeaveRequest
                                  ? selectedLeaveRequest.firstname
                                  : ""}{" "}
                                {selectedLeaveRequest
                                  ? selectedLeaveRequest.lastname
                                  : ""}
                              </div>

                              <div className="col-md-3">
                                <strong className="center">
                                  Type de congé
                                </strong>
                                <br></br>
                                {selectedLeaveRequest
                                  ? selectedLeaveRequest.nomConge
                                  : ""}{" "}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-12">
                        <div class="card">
                          <div className="card-header">
                            <h5>Congé</h5>
                          </div>
                          <div class="card-body">
                            <div class="row">
                              <div className="col-md-3">
                                <strong className="center">Date début</strong>
                                <br></br>
                                {selectedLeaveRequest
                                  ? selectedLeaveRequest.dateDeb
                                  : ""}{" "}
                              </div>

                              <div className="col-md-3">
                                <strong className="center">Date fin</strong>
                                <br></br>
                                {selectedLeaveRequest
                                  ? selectedLeaveRequest.dateFin
                                  : ""}
                              </div>
                              <div className="col-md-3">
                                <strong className="center">
                                  Nombre de jours
                                </strong>
                                <br></br>
                                {differenceEnJours ? differenceEnJours : ""}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-12">
                        <div className="card">
                          <div className="card-header">
                            <h5>Remarque</h5>
                          </div>
                          <div className="card-body">
                            <p>
                              {selectedLeaveRequest
                                ? selectedLeaveRequest.remarque
                                : ""}
                            </p>{" "}
                          </div>
                        </div>
                      </div>
                      {selectedLeaveRequest && selectedLeaveRequest.fileUrl && (
                        <div className="col-md-12">
                          <div className="card card-dark">
                            <div className="card-header ">
                              <h5>Piéce justificative</h5>
                            </div>
                            <div
                              className="card-body"
                              onClick={(e) => {
                                onUploadFileHandler(
                                  selectedLeaveRequest.fileUrl
                                );
                              }}
                              style={{ cursor: "pointer" }}
                            >
                              VOIR PIECE JUSTIFICATIF
                            </div>
                          </div>
                        </div>
                      )}
                    </Row>
                  </Container>
                </Form>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                  Fermer
                </Button>
              </Modal.Footer>
            </Modal>
            {/* Modifier congé en attente */}
            <Modal show={showModify} onHide={handleCloseModify} size="xl">
              <Modal.Header closeButton>
                <Modal.Title>Modidier informations</Modal.Title>
              </Modal.Header>
              <Modal.Body className="show-grid">
                <Form onSubmit={handleUpdate}>
                  <Container>
                    <Row>
                      <div className="col-md-12">
                        <div className="card-body">
                          <div className="form-group">
                            <label for="exampleSelectBorder">
                              Type de congés
                            </label>
                            <select
                              className="custom-select form-control-border"
                              name="idLeaveType"
                              onChange={(e) =>
                                setSelectedLeaveRequestForModify({
                                  ...selectedLeaveRequestForModify,
                                  idLeaveType: e.target.value,
                                })
                              }
                              id="exampleSelectBorder"
                            >
                              <option value="leaveType" disabled>
                                {selectedLeaveRequestForModify
                                  ? selectedLeaveRequestForModify.nomConge
                                  : ""}
                              </option>
                              {leaveType.map((l) => (
                                <option key={l.id} value={l.id}>
                                  {l.nomConge}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="card-body">
                          <div className="form-group">
                            <label>Date de début de congé</label>
                            <div className="input-group date">
                              <input
                                type="date"
                                name="dateDeb"
                                defaultValue={
                                  selectedLeaveRequestForModify
                                    ? selectedLeaveRequestForModify.dateDeb
                                    : ""
                                }
                                onChange={(e) => {
                                  const startDate = e.target.value;
                                  const endDate = selectedLeaveRequestForModify
                                    ? selectedLeaveRequestForModify.dateFin
                                    : "";
                                  const diffInDays = calculateDateDifference(
                                    startDate,
                                    endDate
                                  );
                                  setSelectedLeaveRequestForModify({
                                    ...selectedLeaveRequestForModify,
                                    dateDeb: startDate,
                                    dateFin: endDate,
                                    nbJrs: diffInDays,
                                  });
                                }}
                                className="form-control form-control-border"
                              />
                            </div>
                          </div>
                          <div className="form-group">
                            <label>Nombre de jours</label>
                            <div className="input-group date">
                              <input
                                type="number"
                                disabled
                                name="nbJrs"
                                value={
                                  selectedLeaveRequestForModify
                                    ? selectedLeaveRequestForModify.nbJrs
                                    : ""
                                }
                                className="form-control form-control-border"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="card-body">
                          <div className="form-group">
                            <label>Date de fin de congé</label>
                            <div className="input-group date">
                              <input
                                type="date"
                                name="dateFin"
                                defaultValue={
                                  selectedLeaveRequestForModify
                                    ? selectedLeaveRequestForModify.dateFin
                                    : ""
                                }
                                onChange={(e) => {
                                  const startDate =
                                    selectedLeaveRequestForModify
                                      ? selectedLeaveRequestForModify.dateDeb
                                      : "";
                                  const endDate = e.target.value;
                                  const diffInDays = calculateDateDifference(
                                    startDate,
                                    endDate
                                  );
                                  setSelectedLeaveRequestForModify({
                                    ...selectedLeaveRequestForModify,
                                    dateDeb: startDate,
                                    dateFin: endDate,
                                    nbJrs: diffInDays,
                                  });
                                }}
                                className="form-control form-control-border"
                              />
                            </div>
                          </div>
                          <div className="form-group">
                            <label for="exampleInputPassword1">Remarque</label>
                            <textarea
                              type="Textarea"
                              rows="2"
                              cols="33"
                              value={
                                selectedLeaveRequestForModify
                                  ? selectedLeaveRequestForModify.remarque
                                  : ""
                              }
                              onChange={(e) =>
                                setSelectedLeaveRequestForModify({
                                  ...selectedLeaveRequestForModify,
                                  remarque: e.target.value,
                                })
                              }
                              className="form-control form-control-border"
                              id="exampleInputPassword1"
                              placeholder="Description"
                            ></textarea>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-6">
                        {selectedLeaveRequest &&
                          selectedLeaveRequest.fileUrl && (
                            <div className="col-md-12">
                              <div className="card card-dark">
                                <div className="card-header ">
                                  <h5>Piéce justificative</h5>
                                </div>
                                <div
                                  className="card-body"
                                  onClick={(e) => {
                                    onUploadFileHandler(
                                      selectedLeaveRequest.fileUrl
                                    );
                                  }}
                                  style={{ cursor: "pointer" }}
                                >
                                  VOIR PIECE JUSTIFICATIF
                                </div>
                              </div>
                            </div>
                          )}
                        <div className="form-group">
                          <label
                            htmlFor="fileInput"
                            className="btn btn-dark col fileinput-button mb-2"
                          >
                            <span>
                              {" "}
                              {selectedFile ? (
                                <p>{selectedFile}</p>
                              ) : (
                                <>
                                  {" "}
                                  <i className="fas fa-plus"></i>
                                  <span>Pièce justificative</span>
                                </>
                              )}
                            </span>
                          </label>
                          <input
                            ref={fileInputRef}
                            id="fileInput"
                            type="file"
                            style={{ display: "none" }}
                            onChange={(event) => {
                              const selectedFile = event.target.files[0];
                              setFile(selectedFile);
                              setSelectedFile(selectedFile.name);
                            }}
                            accept="image/jpeg,image/png,application/pdf"
                          />
                        </div>
                      </div>
                    </Row>
                  </Container>
                </Form>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={handleCloseModify}>
                  Fermer
                </Button>
                <Button variant="dark" onClick={handleUpdate}>
                  Modifier
                </Button>
              </Modal.Footer>
            </Modal>

            {/* header */}
            <div className="content-header">
              <div className="container-fluid">
                <div className="row mb-2">
                  <div className="col-sm-6">
                    <h1 className="m-0">Liste des demandes de congé</h1>
                  </div>
                  <div className="col-sm-6">
                    <ol className="breadcrumb float-sm-right">
                      <li className="breadcrumb-item">
                        <i class="fa-solid fa-house"></i>
                      </li>
                      <li className="breadcrumb-item">
                        <Link to="/employee">Home</Link>
                      </li>
                      <li className="breadcrumb-item active">
                        Liste des demandes de congé
                      </li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>

            <div class="container-fluid">
              <div class="row">
                <div class="col-12 col-sm-6 col-md-3">
                  <div class="info-box">
                    <span class="info-box-icon bg-success elevation-1">
                      <i class="fa-regular fa-calendar-check"></i>
                    </span>

                    <div class="info-box-content">
                      <span class="info-box-text">Jours approuvé</span>
                      <span class="info-box-number">
                        {info ? info.approved : 0}
                      </span>
                    </div>
                  </div>
                </div>

                <div class="col-12 col-sm-6 col-md-3">
                  <div class="info-box mb-3">
                    <span class="info-box-icon bg-info elevation-1">
                      <i class="fa-regular fa-calendar-days"></i>
                    </span>

                    <div class="info-box-content">
                      <span class="info-box-text">Jours en attente</span>
                      <span class="info-box-number">
                        {info ? info.pending : 0}
                      </span>
                    </div>
                  </div>
                </div>

                <div class="clearfix hidden-md-up"></div>

                <div class="col-12 col-sm-6 col-md-3">
                  <div class="info-box mb-3">
                    <span class="info-box-icon bg-danger elevation-1">
                      <i class="fa-solid fa-xmark"></i>
                    </span>

                    <div class="info-box-content">
                      <span class="info-box-text">Jours rejeté</span>
                      <span class="info-box-number">
                        {info ? info.rejected : 0}
                      </span>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-sm-6 col-md-3">
                  <div class="info-box mb-3">
                    <span class="info-box-icon bg-warning elevation-1">
                      <i class="fa-solid fa-clock-rotate-left"></i>
                    </span>

                    <div class="info-box-content">
                      <span class="info-box-text">Jours restant</span>
                      <span class="info-box-number">
                        {info ? info.remainingDays : 0}
                      </span>
                    </div>
                  </div>
                </div>
                {info && info.daysOver ? (
                  <>
                    {" "}
                    <div class="col-12 col-sm-6 col-md-3">
                      <div class="info-box mb-3">
                        <span class="info-box-icon bg-warning elevation-1">
                          <i class="fa-solid fa-plus"></i>{" "}
                        </span>

                        <div class="info-box-content">
                          <span class="info-box-text">Jours écoulés</span>
                          <span class="info-box-number">
                            {info ? info.daysOver : 0}
                          </span>
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  <></>
                )}
              </div>
              <div className="row">
                <div className="col-md-11 col-lg-11 col-sm-12 right mb-2">
                  <Link to="/leaveRequest">
                    <button
                      type="button"
                      className="btn btn-dark float-right"
                      style={{ width: "auto", margin: "auto" }}
                    >
                      Demander une autorisation de congé
                    </button>
                  </Link>
                </div>
              </div>

              <div class="row">
                <div class="col-12">
                  <div class="card">
                    <div class="card-header">
                      <h3 class="card-title">Liste des demandes de congé</h3>
                    </div>
                    {/* table */}
                    <BootstrapTable
                      {...props.baseProps}
                      data={leaveRequests}
                      columns={columns}
                      pagination={paginationFactory(options)}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </ToolkitProvider>
    </div>
  );
};

export default EmployeeLeaveRequests;
